export default {"src":"/_next/static/media/cartSummaryArrow.78b1ad79.svg","height":5,"width":9};